<template>
  <v-sheet max-width="800" class="mx-auto pa-6">
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <div v-else>
      <div class="mb-6">
        <h1 class="display-1 mb-3"><ressource code="titre" /></h1>
        <v-divider class="my-3"></v-divider>
        <ressource code="sous-titre" hide-if-empty />
      </div>
      <v-form v-model="valid" ref="formulaire" :disabled="envoiEnCours">
        <v-row>
          <v-col cols="6" class="pb-0">
            <opq-text-field
              v-model="formulaire.prenom"
              code="prenom"
              optional
            />
          </v-col>
          <v-col cols="6" class="pb-0">
            <opq-text-field
              v-model="formulaire.nom"
              code="nom"
              optional
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="pb-0">
            <opq-text-field 
              v-model="formulaire.courriel"
              code="courriel"
              is-email 
              :optional="courrielOptional"
            />
          </v-col>
          <v-col cols="6" class="pb-0">
            <opq-text-field
              v-model="formulaire.numeroTelephone"
              code="numero_telephone"
              is-phone-number
              :optional="numeroTelephoneOptional"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="pb-0">
            <opq-text-field v-model="formulaire.numeroPermis" code="numero_permis" optional />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <opq-catalogue v-model="formulaire.sujet" code="sujet" :filter="filtreSujet" optional />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <opq-text-field v-model="formulaire.objetDeLaDemande" code="objet" width="100%" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <opq-memo v-model="formulaire.message" code="message" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <opq-memo v-model="formulaire.disponibilites" code="disponibilite" optional />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <opq-case :opq-if="!!formulaire.courriel" code="souhaite_recevoir_copie" v-model="formulaire.demandeCopie" optional></opq-case>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <opq-case code="consentement" v-model="formulaire.consentement"></opq-case>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-alert type="success" text v-show="envoiReussi"><ressource code="message_envoye" /></v-alert>
            <v-alert type="error" text v-show="echecEnvoi">
              <ressource code="message_erreur" />
              <ul v-if="erreurs.length > 0">
                <li v-for="erreur in erreurs" :key="erreur">{{ erreur }}</li>
              </ul>
            </v-alert>
            <v-btn @click="send" color="primary" large :disabled="envoiEnCours"
              ><ressource code="bouton_envoyer" /><v-icon class="ml-3">mdi-send</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-sheet>
</template>

<script>
import ParamFormulaireBase from "@/mixins/FormulaireBase"
import FormulaireDemandeModel from "@/models/FormulaireDemandeModel"
import { Api } from "@/plugins/api"

export default {
  mixins: [ParamFormulaireBase],
  data() {
    return {
      valid: false,
      envoiEnCours: false,
      envoiReussi: false,
      echecEnvoi: false,
      erreurs: [],
      formulaire: new FormulaireDemandeModel()
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  },
  mounted() {
    this.loadParams("demande")
  },
  computed: {
    courrielOptional() {
      return this.formulaire.numeroTelephone !== ""
    },
    numeroTelephoneOptional() {
      return this.formulaire.courriel !== ""
    }
  },
  methods: {
    filtreSujet(fd) {
      return fd.code.includes("web")
    },
    reset() {
      this.formulaire = new FormulaireDemandeModel()
      this.$refs.formulaire.resetValidation()
    },
    resetFlags() {
      this.envoiEnCours = false
      this.envoiReussi = false
      this.echecEnvoi = false
      this.erreurs = []
    },
    send() {
      this.resetFlags()
      if (this.$refs.formulaire.validate()) {
        this.envoiEnCours = true
        Api.post("demandes", this.formulaire)
          .then((res) => {
            if (res.data.hasValidationErrors) {
              this.erreurs = res.data.errors
              this.echecEnvoi = true
            } else {
              this.reset()
              this.envoiReussi = true
            }
          })
          .catch(() => {
            this.echecEnvoi = true
          })
          .finally(() => {
            this.envoiEnCours = false
          })
      }
    }
  }
}
</script>

<style></style>
